export type Lang = "es" | "en";

type Dict = Record<string, string>;

const ES: Dict = {
  // Cabecera / navegación
  app_title: "Westive",
  acts_datos_al: "{n} actividades · {update}",
  upd_today: "actualizado hoy",
  upd_yesterday: "actualizado ayer",
  upd_days: "actualizado hace {d} días",
  warn_sync:
    "Tus datos de actividad no se sincronizan desde hace {d} días. Revisa la conexión de tu dispositivo.",
  warn_garmin:
    "Garmin no se sincroniza desde hace {d} días. El token de Garmin puede haber caducado: vuelve a ejecutar garmin_login.py y actualiza el secret GARMIN_TOKEN.",
  // Rangos
  range_30d: "30 días",
  range_week: "Semana",
  range_3m: "3 meses",
  range_12m: "12 meses",
  range_all: "Todo",
  // Tabs
  tab_resumen: "Resumen",
  tab_carrera: "Carrera",
  tab_material: "Material",
  tab_carga: "Carga",
  tab_coach: "Coach",
  tab_add: "Añadir deporte",
  tab_add_empty: "No hay más deportes con datos.",
  sync: "Sincronizar",
  syncing: "Sincronizando…",
  sync_rate_limited:
    "Strava ha limitado temporalmente las peticiones. El progreso queda guardado; prueba de nuevo en unos minutos.",
  sync_timeout:
    "La sincronización sigue en segundo plano o tardó más de lo previsto. Recarga o vuelve a sincronizar en unos minutos.",
  // Coach (IA)
  coach_title: "Tu Coach IA",
  coach_intro:
    "Pregúntame por tu estado de forma, pídeme el entreno de hoy o una propuesta para organizar la próxima semana. Conozco tus zonas, tu carga (CTL/ATL/TSB) y tus últimos entrenos.",
  coach_placeholder: "Escribe tu pregunta… (Enter para enviar)",
  coach_send: "Enviar",
  coach_thinking: "Pensando…",
  coach_error: "Error",
  coach_disclaimer: "Asistente en pruebas. No sustituye consejo médico ni profesional.",
  coach_s1: "¿Cómo estoy de forma?",
  coach_s2: "¿Qué entreno hago hoy?",
  coach_s3: "Organiza mi próxima semana",
  coach_rate: "Demasiadas peticiones seguidas. Espera unos segundos e inténtalo de nuevo.",
  coach_credit: "{remaining}/{limit} tokens estimados",
  coach_credit_hint: "Crédito diario estimado del Coach IA. Se reinicia a medianoche UTC.",
  coach_goals: "Objetivos",
  coach_workouts: "Próximos entrenos",
  coach_no_goals: "Sin objetivos activos.",
  coach_no_workouts: "Sin entrenos planificados.",
  coach_goal_placeholder: "Evento u objetivo: Media Maratón Valencia, Hyrox Madrid…",
  coach_workout_placeholder: "Título del entreno",
  coach_workout_notes: "Notas, bloques, ritmos o zonas",
  coach_add_goal: "Guardar objetivo",
  coach_save_goal: "Guardar cambios",
  coach_add_workout: "Guardar entreno",
  coach_mark_done: "Marcar completado",
  coach_done_short: "Hecho",
  coach_pinned_goal: "Objetivo fijado",
  coach_goal_empty_desc:
    "Fija un objetivo para que el Coach pueda contextualizar mejor tus respuestas. No hace falta indicar deporte: lo inferirá por el nombre.",
  coach_edit_goal: "Editar",
  coach_archive_goal: "Archivar",
  coach_delete_goal: "Borrar",
  coach_cancel_goal: "Cancelar",
  coach_goal_saved: "Objetivo guardado",
  coach_goal_archived: "Objetivo archivado",
  coach_goal_deleted: "Objetivo borrado",
  coach_delete_goal_confirm: "¿Borrar este objetivo? No se puede deshacer.",
  coach_memory_title: "Memoria del Coach",
  coach_memory_desc:
    "Hechos que el Coach recuerda de ti entre conversaciones (lesiones, marcas, preferencias…). Los usas para que personalice mejor.",
  coach_memory_empty: "Aún no has guardado hechos. Añade lo que quieras que el Coach tenga siempre presente.",
  coach_memory_placeholder: "Ej: molestia recurrente en sóleo izquierdo",
  coach_memory_add: "Añadir",
  coach_memory_save: "Guardar",
  coach_memory_delete_confirm: "¿Borrar este hecho de la memoria del Coach?",
  coach_mem_kind_injury: "Lesión",
  coach_mem_kind_preference: "Preferencia",
  coach_mem_kind_mark: "Marca/PR",
  coach_mem_kind_constraint: "Restricción",
  coach_mem_kind_equipment: "Material",
  coach_mem_kind_note: "Nota",
  coach_memory_pending_title: "Sugerencias por revisar",
  coach_memory_pending_desc:
    "El Coach ha detectado estos hechos en tus conversaciones. Apruébalos para que los recuerde o descártalos.",
  coach_memory_approve: "Aprobar",
  coach_memory_discard: "Descartar",
  coach_memory_review_badge: "{n} por revisar",
  coach_goal_date: "Fecha: {date}",
  coach_goal_time: "Tiempo objetivo: {time}",
  coach_no_date: "Sin fecha",
  coach_no_time: "Sin tiempo objetivo",
  coach_no_goal_for_prompt: "aún sin objetivo fijado",
  coach_ask_plan: "Pedir plan al Coach",
  coach_ask_plan_hint: "Te prepara una pregunta; el plan persistente lo reservamos para la vista de entrenador.",
  coach_plan_prompt:
    "Con mi objetivo {goal}, propón una planificación razonable para las próximas 2 semanas. Usa mis datos de carga, fatiga, forma y salud si están disponibles. Quiero sesiones concretas, días de descanso y ajustes si detectas riesgo.",
  coach_ask_load: "Preguntar al Coach",
  coach_ask_period: "Analizar con Coach",
  coach_prompt_load_now:
    "Analiza mi estado actual de carga con estos datos: fecha {date}, CTL {ctl}, ATL {atl}, TSB {tsb}. Dime qué debería entrenar hoy y qué riesgo ves.",
  coach_prompt_load_range:
    "Analiza este periodo de entrenamiento ({from} a {to}, {n} actividades). Resume qué ves en la carga, fatiga y recuperación, y propón ajustes para la próxima semana.",
  coach_ask_health: "Analizar salud con Coach",
  coach_prompt_health:
    "Revisa mis datos de salud y recuperación recientes (sueño, readiness, HRV, FC en reposo, Body Battery si los hay). Dime cómo estoy de recuperado y qué debería entrenar hoy.",
  coach_ask_overview: "Analizar resumen con Coach",
  coach_prompt_overview:
    "Mira mi resumen de entrenamiento reciente (volumen, frecuencia y reparto por disciplina). Dime qué ves bien, qué corregiría y cómo enfocar la próxima semana.",
  // Pie de página
  footer_by: "Creado por",
  footer_contact: "Contacto",
  egg_msg: "Has sido bendecido/a por la Champi de la fortuna, te espera un año de buena suerte",
  egg_close: "Pulsa o haz clic para cerrar",
  // Categorías
  cat_Carrera: "Carrera",
  cat_Ciclismo: "Ciclismo",
  cat_Natacion: "Natación",
  cat_Hybrid: "Hybrid",
  cat_Hike: "Senderismo",
  cat_Musculacion: "Musculación",
  cat_Otros: "Otros",
  // KPIs
  kpi_actividades: "Actividades",
  kpi_kilometros: "Kilómetros",
  kpi_horas: "Horas",
  kpi_carga_total: "Carga total",
  kpi_calorias: "Calorías",
  kpi_carreras: "Carreras",
  kpi_km: "Km",
  kpi_ritmo_medio: "Ritmo medio",
  kpi_mejor_ritmo: "Mejor ritmo",
  kpi_sesiones: "Sesiones",
  kpi_avg_hr: "FC media",
  kpi_fitness: "Fitness (CTL)",
  kpi_fatiga: "Fatiga (ATL)",
  kpi_forma: "Forma (TSB)",
  kpi_over_days: "en {d} días",
  // Secciones
  sec_volumen: "Volumen semanal (km)",
  sec_reparto: "Reparto por tipo",
  sec_acts_periodo: "Actividades del periodo",
  sec_ultimas: "Últimas actividades",
  sec_evol_ritmo: "Evolución del ritmo",
  sec_evol_velocidad: "Evolución de la velocidad",
  sec_evol_potencia: "Evolución de la potencia",
  sec_evol_ritmo100: "Evolución del ritmo (/100m)",
  sec_evol_esfuerzo: "Evolución del esfuerzo",
  m_speed: "Velocidad",
  m_power: "Potencia",
  m_elev: "Desnivel",
  m_cadence: "Cadencia",
  m_swolf: "SWOLF",
  m_kj: "Trabajo",
  m_pace100: "Ritmo /100m",
  th_velocidad: "Vel.",
  th_potencia: "Pot.",
  th_cadencia: "Cad.",
  th_swolf: "SWOLF",
  th_ritmo100: "Ritmo /100m",
  d_velocidad: "Velocidad",
  d_potencia: "Potencia",
  d_cadencia: "Cadencia",
  d_swolf: "SWOLF",
  d_temp: "Temperatura",
  sec_zonas: "Reparto del tiempo por zona de FC",
  sec_frecuencia: "Frecuencia semanal",
  sec_seguimiento: "Seguimiento semanal",
  sec_wods: "Detalle de sesiones",
  sec_km_zapatilla: "Kilometraje por zapatilla",
  sec_ctl_atl: "Fitness (CTL) vs Fatiga (ATL)",
  sec_tsb: "Forma (TSB = Fitness − Fatiga)",
  // Tabla
  th_fecha: "Fecha",
  th_actividad: "Actividad",
  th_tipo: "Tipo",
  th_km: "Km",
  th_ritmo: "Ritmo",
  th_tiempo: "Tiempo",
  th_hr: "FC media",
  th_max_hr: "FC máx",
  th_esfuerzo: "Esfuerzo",
  th_carga: "Carga",
  th_calorias: "Calorías",
  pg_show: "Mostrar",
  pg_prev: "Anterior",
  pg_next: "Siguiente",
  pg_page: "Página {page}/{total}",
  pg_of_total: "{from}–{to} de {total}",
  // Detalle
  d_fecha_hora: "Fecha y hora",
  d_deporte: "Deporte",
  d_distancia: "Distancia",
  d_duracion: "Duración",
  d_ritmo: "Ritmo",
  d_vel_media: "Vel. media",
  d_desnivel: "Desnivel",
  d_calorias: "Calorías",
  d_hr: "FC media",
  d_max_hr: "FC máx",
  d_carga: "Carga (esfuerzo rel.)",
  d_kudos: "Kudos",
  d_pr: "Récords (PR)",
  d_material: "Material",
  // Métricas seleccionables del gráfico de seguimiento
  m_entrenos: "Entrenos",
  m_km: "Km",
  m_pace: "Ritmo",
  m_cal: "Calorías",
  m_sesiones: "Sesiones",
  m_horas: "Horas",
  m_carga: "Carga",
  m_hr: "FC media",
  m_heatmap: "Heatmap",
  heat_menos: "menos",
  heat_mas: "más",
  heat_hue: "color = deporte · intensidad = duración",
  // Hints / textos
  hint_chart: "Clic en una semana para filtrar · arrastra el selector inferior para ampliar",
  hint_chart_day: "Clic en un día para filtrar · arrastra el selector inferior para ampliar",
  hint_donut: "Clic en un tipo para filtrar",
  hint_dia: "Clic en un día para filtrar",
  hint_punto: "Clic en un punto para ver esa actividad",
  hint_semana: "Clic en una fecha para ver las actividades de esa semana",
  hint_carga: "Clic = semana · arrastra para seleccionar un rango",
  hint_fila: "clic en una fila para ver el detalle",
  txt_n_acts: "{n} actividades",
  txt_sin_acts: "No hay actividades en este periodo.",
  txt_sin_disciplina: "No hay actividades de {cat} en este rango.",
  txt_sin_carga: "Sin datos de carga.",
  gear_active: "En uso",
  gear_retired: "Retirada",
  gear_usage: "Uso",
  // Zonas de FC (nombres de Strava) y textos del donut
  zone_1: "Recuperación",
  zone_2: "Resistencia",
  zone_3: "Ritmo",
  zone_4: "Umbral",
  zone_5: "Anaeróbico",
  z_tiempo: "Tiempo",
  z_pct: "% del tiempo",
  ref_zonas: "Aproximado por la FC media de cada carrera (no por streams segundo a segundo).",
  ref_zapatillas: "Referencia habitual: revisar/renovar zapatillas de asfalto entre 600–900 km.",
  ref_tsb: "TSB positivo = descansado · TSB muy negativo = fatiga acumulada (riesgo si se mantiene).",
  tsb_fatiga: "Fatiga acumulada",
  tsb_fresco: "Fresco",
  tsb_equilibrio: "Equilibrio",
  legend_fitness: "Fitness",
  legend_fatiga: "Fatiga",
  legend_forma: "Forma",
  unit_min: "min",
  unit_sesiones: "sesiones",
  // Tooltips informativos (big numbers)
  info_carga:
    "Suma del 'esfuerzo relativo' en el periodo mostrado. Es un proxy del estrés de cada sesión (combina intensidad y duración): a mayor número, más exigente fue el entrenamiento.",
  info_calorias:
    "Suma de las calorías estimadas en el periodo mostrado (kcal). Es una estimación a partir del esfuerzo y la duración de cada actividad.",
  info_ctl:
    "CTL = Chronic Training Load («carga crónica de entrenamiento»), es decir Fitness: media móvil exponencial a 42 días de la carga. Tu forma de fondo acumulada: sube despacio con entrenamiento sostenido.",
  info_atl:
    "ATL = Acute Training Load («carga aguda de entrenamiento»), es decir Fatiga: media móvil exponencial a 7 días de la carga. Cansancio reciente: sube rápido tras sesiones duras.",
  info_tsb:
    "TSB = Training Stress Balance («balance de estrés de entrenamiento»), es decir Forma = Fitness − Fatiga. Positivo = descansado y listo; muy negativo = fatiga acumulada y riesgo si se mantiene.",
  // --- Salud (Garmin) ---
  seg_fitness: "Fitness",
  seg_salud: "Salud",
  seg_coach: "Coach IA",
  tab_s_resumen: "Resumen",
  tab_s_sueno: "Sueño",
  tab_s_cuerpo: "Cuerpo",
  tab_s_cruce: "Readiness",
  h_sleep_score: "Sueño (score)",
  h_readiness: "Readiness",
  h_hrv: "HRV",
  h_rhr: "FC reposo",
  h_vo2: "VO2máx",
  h_stress: "Estrés",
  h_body_battery: "Body Battery",
  h_last_night: "última noche",
  h_sleep_dur: "Duración sueño",
  h_resp: "Respiración",
  h_avg: "media del periodo",
  h_total: "total del periodo",
  h_kpis_caption: "Medias del periodo seleccionado",
  vo2_1: "Deficiente",
  vo2_2: "Por debajo del promedio",
  vo2_3: "Promedio",
  vo2_4: "Por encima del promedio",
  vo2_5: "Bueno",
  vo2_6: "Excelente",
  sec_h_overview: "Readiness y sueño",
  sec_h_hrv: "HRV y FC en reposo",
  sec_h_sleep: "Sueño: fases (h) y score",
  sec_h_bb: "Body Battery y estrés",
  sec_h_cross: "Forma (TSB) vs recuperación",
  st_deep: "Profundo",
  st_light: "Ligero",
  st_rem: "REM",
  st_awake: "Despierto",
  h_no_data: "Sin datos de salud en este periodo.",
  h_cross_hint:
    "Cruce de tu carga de entrenamiento (TSB) con tu recuperación (Readiness y HRV, de Garmin).",
  h_corr_na: "datos insuficientes",
  h_corr_weak: "correlación débil",
  h_corr_pos: "a más forma, mejor recuperación",
  h_corr_neg: "a más forma, peor recuperación",
  h_corr_tsb_hrv: "Correlación TSB ↔ HRV",
  h_corr_tsb_rdy: "Correlación TSB ↔ Readiness",
  h_steps: "Pasos",
  health_distance: "Distancia",
  body_title: "Composición corporal",
  body_weight: "Peso",
  body_fat: "% Grasa",
  body_muscle: "Músculo",
  body_chest: "Pecho",
  body_waist: "Cintura",
  body_hip: "Cadera",
  body_arm: "Brazo",
  body_thigh: "Muslo",
  body_note: "Nota",
  body_add: "Guardar registro",
  body_empty: "Sin registros aún. Añade tu primer dato de composición corporal.",
  body_date: "Fecha",
  body_del: "Borrar",
  sec_h_vo2: "Evolución de VO2máx",
  sec_h_steps: "Pasos diarios",
  h_avg_hr: "FC",
  h_calories: "Calorías",
  sec_h_activity: "Pasos y calorías",
  sec_h_sleepstress: "Sueño y estrés",
  sec_h_avghr: "FC media diaria y en reposo",
  info_h_avghr:
    "FC media del día: promedio de tu frecuencia cardiaca a lo largo de todo el día (incluye actividad y reposo). Sube los días con más entreno o estrés.",
  info_h_cal: "Calorías totales quemadas en el día según Garmin: metabolismo basal (en reposo) + actividad.",
  sec_h_hr_day: "FC intradía (un día)",
  sec_h_table: "Resumen diario",
  h_day: "Día",
  h_hr_bpm: "FC (ppm)",
  th_garmin: "Garmin",
  h_garmin_link: "Ver el día en Garmin Connect",
  info_h_readiness:
    "Readiness (Garmin): 0–100 de cuán preparado estás para entrenar hoy. Combina sueño reciente, HRV, carga aguda y recuperación. Alto = listo para calidad; bajo = prioriza descanso.",
  info_h_hrv:
    "HRV: variabilidad de la frecuencia cardiaca nocturna (ms). Refleja el equilibrio del sistema nervioso; más alta y estable suele indicar mejor recuperación.",
  info_h_vo2:
    "VO2máx: estimación del consumo máximo de oxígeno (ml/kg/min). Proxy de tu capacidad aeróbica; sube con el entrenamiento de fondo.",
  info_h_rhr:
    "FC en reposo: pulsaciones por minuto en reposo. Tiende a bajar con la forma física; subidas puntuales pueden indicar fatiga o estrés.",
  info_h_stress:
    "Estrés (Garmin): 0–100 calculado a partir de la HRV durante el día. Bajo = relajado/recuperando; alto = tensión física o mental.",
  info_h_sleep:
    "Score de sueño (Garmin): 0–100 según duración, fases (profundo/REM/ligero), despertares y estrés nocturno.",
  info_h_bb:
    "Body Battery: 0–100 de energía estimada. Se recarga con descanso y sueño; se drena con actividad y estrés.",

  // Calendario / planned_workouts
  tab_calendario: "Calendario",
  cal_plan_tab: "Plan",
  cal_week_prev: "← Anterior",
  cal_week_next: "Siguiente →",
  cal_month_prev: "Anterior",
  cal_month_next: "Siguiente",
  cal_activity_done: "Hecho",
  cal_no_workouts: "Sin entrenos planificados este mes.",
  cal_empty_athlete: "Sin entrenos de tu entrenador este mes.",
  cal_new_workout: "Nuevo entreno",
  cal_edit_workout: "Editar entreno",
  cal_title_label: "Título",
  cal_sport_label: "Deporte",
  cal_intensity_label: "Intensidad",
  cal_duration_label: "Duración (min)",
  cal_description_label: "Notas / descripción",
  cal_status_label: "Estado",
  cal_status_draft: "Borrador",
  cal_status_published: "Publicado",
  cal_status_done: "Hecho",
  cal_status_skipped: "Saltado",
  cal_save: "Guardar",
  cal_publish: "Guardar y publicar",
  cal_delete: "Eliminar",
  cal_cancel: "Cancelar",
  cal_delete_confirm: "¿Eliminar este entreno? No se puede deshacer.",
  cal_mark_done: "Marcar hecho",
  cal_mark_skipped: "Saltar",
  cal_today: "Hoy",
  cal_open_picker: "Seleccionar mes",
  cal_int_easy: "Suave",
  cal_int_moderate: "Moderado",
  cal_int_hard: "Intenso",
  cal_int_rest: "Descanso",
  cal_sport_Hyrox: "Hyrox",
  cal_sport_Fuerza: "Fuerza",
  cal_sport_Movilidad: "Movilidad",
  cal_sport_Descanso: "Descanso",
  cal_sport_Otro: "Otro",
  // Panel de entrenador
  coach_view_athlete: "Mi entrenamiento",
  coach_view_coach: "Zona coach",
  coach_roster_title: "Mis atletas",
  coach_subtab_athletes: "Atletas",
  nav_group_principal: "Principal",
  nav_group_red: "Red",
  nav_entrenamiento: "Entrenamiento",
  nav_collapse: "Colapsar sidebar",
  nav_expand: "Expandir sidebar",
  nav_red_athlete: "Mi entrenador",
  nav_red_entrenador: "Entrenador",
  nav_red_coach: "Atletas",
  nav_red_coach_zone: "Zona de coach",
  nav_red_messages: "Mensajes",
  nav_red_codes: "Códigos",
  nav_settings: "Ajustes",
  profile_role_athlete: "Atleta",
  profile_role_coach: "Entrenador/a",
  coach_roster_empty: "Aún no tienes atletas vinculados.",
  coach_roster_empty_hint:
    "Comparte tu código de entrenador con tus atletas para que se vinculen a tu panel.",
  coach_col_athlete: "Atleta",
  coach_col_tsb: "Forma",
  coach_col_readiness: "Readiness",
  coach_col_sleep: "Sueño",
  coach_col_bb: "Body Battery",
  coach_col_sessions: "Sesiones (sem.)",
  coach_back_roster: "← Mis atletas",
  coach_athlete_read: "Perfil del atleta",
  // Notas del coach
  tab_notes: "Notas",
  notes_empty: "No hay notas sobre este atleta.",
  notes_new_placeholder: "Nueva nota…",
  notes_visibility_private: "Privada",
  notes_visibility_shared: "Compartida",
  notes_add: "Añadir nota",
  notes_save: "Guardar",
  notes_cancel: "Cancelar",
  notes_delete: "Eliminar",
  notes_delete_confirm: "¿Eliminar esta nota?",
  notes_shared_badge: "Compartida",
  notes_private_badge: "Privada",
  // Coach link codes (Fase 7)
  my_coach_tab: "Mi entrenador",
  my_coach_no_coach: "No tienes entrenador vinculado.",
  my_coach_enter_code: "Introduce el código de tu entrenador",
  my_coach_code_placeholder: "CCH-XXXXXXX",
  my_coach_preview: "Verificar código",
  my_coach_consent_title: "Vincular entrenador",
  my_coach_consent_body: "Este código te vincula con {coachName}. El entrenador podrá ver tus datos de entrenamiento y salud.",
  my_coach_consent_accept: "Aceptar y vincularme",
  my_coach_consent_cancel: "Cancelar",
  my_coach_linked: "Entrenador vinculado",
  my_coach_unlink: "Desvincularme",
  my_coach_unlink_confirm: "¿Desvincular al entrenador? Ya no podrá ver tus datos.",
  my_coach_error_invalid: "Código inválido o no encontrado.",
  my_coach_error_exhausted: "Este código ya ha sido usado el máximo de veces.",
  my_coach_error_expired: "Este código ha caducado.",
  my_coach_error_self: "No puedes usar tu propio código.",
  my_coach_error_already: "Ya tienes un entrenador vinculado.",
  my_coach_updates: "Entrenamientos próximos",
  my_coach_no_updates: "Sin entrenamientos próximos de tu entrenador.",
  my_coach_see_calendar: "Ver en el calendario",
  my_coach_unlink_section: "Ajustes del vínculo",
  my_coach_no_shareable_banner: "Tu entrenador aún no puede ver tus datos porque no tienes ninguna fuente compartible conectada. Conecta un dispositivo Garmin u otro compatible en Ajustes para que tu entrenador vea tu progreso.",
  coach_roster_no_shareable: "Sin fuente compartible",
  flag_fatigue_high: "Sobrecarga",
  flag_fatigue_high_desc: "TSB muy negativo: riesgo de fatiga acumulada. Considera reducir carga.",
  flag_form_peaked: "Forma pico",
  flag_form_peaked_desc: "TSB alto con carga mantenida: el atleta está fresco. Puede desentrenar si se extiende.",
  flag_readiness_low: "Recuperación baja",
  flag_readiness_low_desc: "Readiness por debajo de 35. El atleta puede necesitar descanso.",
  flag_inactive: "Inactivo",
  flag_inactive_desc: "Sin sesiones en los últimos 7 días.",
  flag_missed_workouts: "Entrenos perdidos",
  flag_missed_workouts_desc: "Tiene entrenos planificados vencidos sin completar.",
  link_codes_title: "Códigos de vínculo",
  link_codes_new: "Nuevo código",
  link_codes_copy: "Copiar",
  link_codes_copied: "¡Copiado!",
  link_codes_disable: "Deshabilitar",
  link_codes_enable: "Habilitar",
  link_codes_empty: "No tienes códigos de vínculo. Crea uno para compartirlo con tus atletas.",
  link_codes_uses: "{uses} / {max} usos",
  link_codes_uses_unlimited: "{uses} usos (sin límite)",
  link_codes_note_placeholder: "Nota opcional (nombre del atleta, grupo…)",
  link_codes_max_placeholder: "Máx. usos (vacío = sin límite)",
  // Mensajería directa (Fase 8)
  msg_tab: "Mensajes",
  msg_empty: "Sin mensajes todavía. ¡Empieza la conversación!",
  msg_placeholder: "Escribe un mensaje…",
  msg_send: "Enviar",
  msg_you: "Tú",
  // Landing (pre-login). Prefijo lp_ = landing page.
  lp_soon: "Pronto",
  lp_nav_features: "Producto",
  lp_nav_coaches: "Entrenadores",
  lp_nav_pricing: "Precios",
  lp_nav_faq: "FAQ",
  lp_signin: "Entrar",
  // Candidatos alternativos: "Entrena con cabeza. Vive con fuerza." / "Entrena fuerte. Vive sano." / "Tu deporte y tu salud, una sola cuenta."
  lp_tagline: "Rendimiento y salud, en sintonía.",
  lp_badge: "Rendimiento + Salud + IA — Garmin y más",
  lp_subtitle:
    "Conecta tu Garmin o cualquier dispositivo compatible y reúne tu rendimiento y tu salud en un solo panel. Con un Coach IA que entiende todo tu historial.",
  lp_cta: "Crear cuenta",
  lp_cta_secondary: "Ver demo",
  demo_badge: "Estás viendo una demo",
  demo_cta_signup: "Crear cuenta",
  demo_exit: "Salir de la demo",
  demo_locked: "Disponible al crear tu cuenta",
  lp_cta_note: "Beta cerrada · Garmin y más · Acceso con código de invitación.",
  // AuthModal (F1 identidad propia)
  auth_tab_register: "Crear cuenta",
  auth_tab_login: "Entrar",
  auth_email_label: "Correo electrónico",
  auth_email_placeholder: "tu@correo.com",
  auth_password_label: "Contraseña",
  auth_password_placeholder: "Mínimo 8 caracteres",
  auth_code_label: "Código de invitación",
  auth_code_placeholder: "Tu código (BET… o CCH…)",
  auth_password2_label: "Repite la contraseña",
  auth_password2_placeholder: "Repite tu contraseña",
  auth_err_password_mismatch: "Las contraseñas no coinciden.",
  auth_register_btn: "Crear cuenta",
  auth_login_btn: "Entrar",
  auth_google_btn: "Continuar con Google",
  auth_err_email_invalido: "Correo no válido.",
  auth_err_password_corto: "La contraseña debe tener al menos 8 caracteres.",
  auth_err_invitacion_requerida: "Necesitas un código de invitación.",
  auth_err_code_before_google: "Introduce tu código de invitación antes de continuar con Google.",
  auth_err_codigo_invalido: "Código inválido o ya utilizado.",
  auth_err_codigo_caducado: "El código ha caducado.",
  auth_err_codigo_agotado: "El código está agotado.",
  auth_err_email_en_uso: "Este correo ya tiene cuenta.",
  auth_err_email_solo_google: "Este correo ya tiene cuenta con Google. Usa el botón 'Entrar con Google'.",
  auth_err_credenciales_incorrectas: "Correo o contraseña incorrectos.",
  auth_err_acceso_pausado: "Tu acceso está pausado.",
  auth_err_registro_fallido: "No pudimos crear la cuenta. Inténtalo de nuevo o escríbenos.",
  auth_err_generic: "Error inesperado. Inténtalo de nuevo.",
  auth_consent_title: "Tu entrenador quiere vincularse",
  auth_consent_body: "{coachName} quiere ser tu entrenador en Westive. Al aceptar, él podrá ver tus datos de entrenamiento de fuentes compartibles. Puedes desvincularlos en cualquier momento.",
  auth_consent_accept: "Aceptar y crear cuenta",
  auth_consent_cancel: "Cancelar",
  identity_section: "Cuenta e identidad",
  identity_method_password: "Contraseña",
  identity_link_google: "Vincular Google",
  // EmptyState (F)
  empty_no_activities: "Aún no hay actividades",
  empty_no_activities_desc: "Conecta una fuente o espera a que terminemos de sincronizar.",
  empty_no_health: "Sin datos de salud",
  empty_no_health_desc: "Conecta Garmin u otra fuente de salud para ver tus métricas.",
  empty_no_gear: "Sin material registrado",
  empty_no_gear_desc: "El material aparece automáticamente cuando sincronizas tus actividades.",
  empty_cta_connect: "Conectar fuente",
  empty_syncing: "Sincronizando tus datos…",
  // ConnectSources (F2)
  connect_title: "Tu cuenta ya está lista",
  connect_desc: "Conecta tu Garmin u otra fuente para empezar a ver tus datos. Puedes hacerlo ahora o más adelante desde Ajustes.",
  connect_skip: "Saltar por ahora",
  connect_go: "Conectar",
  // Pantalla de acceso pausado (usuario bloqueado)
  blocked_title: "Acceso pausado",
  blocked_desc: "Tu acceso a la beta está pausado. Escríbenos si crees que es un error.",
  blocked_logout: "Cerrar sesión",
  // Panel de admin
  admin_title: "Admin",
  admin_loading: "Cargando…",
  admin_slots: "Slots por proveedor",
  admin_slots_desc: "atletas conectados de {cap}",
  admin_codes: "Códigos de invitación",
  admin_users: "Usuarios",
  admin_create_code: "Crear código",
  admin_prefix: "Prefijo (3 letras)",
  admin_prefix_hint: "3 letras A-Z, ej. BET",
  admin_code_kind_beta: "Beta (acceso)",
  admin_code_kind_coach: "Vínculo de coach",
  admin_code_coach_label: "Coach al que vincula",
  admin_code_max_unlimited: "Ilimitado",
  admin_code_delete: "Borrar",
  admin_code_delete_confirm: "¿Borrar este código? Se oculta del panel pero sus datos se conservan.",
  admin_note: "Nota (opcional)",
  admin_type_athlete: "Atleta",
  admin_type_coach: "Coach",
  admin_st_active: "Activo",
  admin_st_disabled: "Desactivado",
  admin_st_redeemed: "Canjeado",
  admin_copy: "Copiar",
  admin_copied: "¡Copiado!",
  admin_enable: "Activar",
  admin_disable: "Desactivar",
  admin_block: "Bloquear",
  admin_unblock: "Desbloquear",
  admin_revoke: "Revocar",
  admin_revoke_confirm:
    "¿Revocar el acceso de este usuario? Se desautoriza la fuente (libera un slot) y se borran sus datos. Tendrá que volver a entrar con un código nuevo.",
  admin_revoke_manual:
    "Acceso revocado y datos borrados, pero no se pudo desconectar de la fuente automáticamente. Para liberar el slot, el atleta debe revocar Westive a mano desde la app del proveedor.",
  admin_revoke_notoken:
    "Hecho en Westive, pero esta cuenta ya no tenía conexión guardada, así que no podemos desconectarla del proveedor por nosotros. Para que baje el contador, el atleta debe revocar Westive desde los ajustes de su proveedor.",
  admin_slots_note:
    "Cuenta las conexiones activas en Westive. El proveedor libera su propio contador solo cuando desautorizamos al atleta (revocar/eliminar con conexión) o cuando él mismo nos quita el acceso desde su cuenta.",
  admin_no_slots: "No hay proveedores con cupo limitado configurados.",
  admin_ai_usage: "Uso de IA (Coach)",
  admin_ai_usage_desc: "Consumo estimado del Coach IA para vigilar el coste de Workers AI durante la beta.",
  admin_ai_today: "Hoy",
  admin_ai_week: "7 días",
  admin_ai_month: "30 días",
  admin_ai_all: "Total",
  admin_ai_tokens_est: "Tokens estimados (caracteres ÷ 4). El día actual se reinicia a medianoche UTC.",
  admin_ai_user: "Usuario",
  admin_ai_requests: "Peticiones",
  admin_ai_anon: "(sin nombre)",
  admin_connected: "Conectado",
  admin_disconnected: "Sin conexión",
  admin_connected_hint: "Tiene una fuente conectada: revocar/eliminar liberará su slot en el proveedor.",
  admin_disconnected_hint:
    "No tiene fuente conectada en Westive: no podemos desconectarlo del proveedor; debe revocar desde su propia cuenta.",
  admin_delete: "Eliminar",
  admin_delete_confirm:
    "¿Eliminar por completo este usuario y TODOS sus datos? Si aún tiene conexión, se libera su slot en el proveedor. Esto no se puede deshacer.",
  admin_blocked: "Bloqueado",
  admin_active: "Activo",
  admin_activities: "act.",
  admin_never: "sin sync",
  admin_redeemed_by: "por",
  admin_no_codes: "No hay códigos todavía.",
  admin_no_users: "No hay usuarios todavía.",
  lp_features_eyebrow: "Todo en un sitio",
  lp_features_title: "Rendimiento y salud, conectados.",
  lp_pillar_perf_t: "Rendimiento",
  lp_pillar_perf_d:
    "Volumen, ritmos, potencia y carga —forma, fatiga y frescura—. Cada actividad analizada con la profundidad que necesitas para progresar.",
  lp_pillar_health_t: "Salud",
  lp_pillar_health_d:
    "Sueño, frecuencia cardíaca, HRV, estrés y batería corporal de tu reloj. Escucha a tu cuerpo para entrenar mejor.",
  lp_pillar_ai_t: "Coach IA",
  lp_pillar_ai_d:
    "Un entrenador inteligente que lee tus datos, planifica tus sesiones y te avisa cuando toca frenar.",
  lp_how_eyebrow: "Cómo funciona",
  lp_how_title: "Empieza en un minuto.",
  lp_step1_t: "Crea tu cuenta",
  lp_step1_d: "Regístrate con email o Google. Sin tarjeta, sin configurar nada.",
  lp_step2_t: "Conecta tus fuentes",
  lp_step2_d: "Enlaza tu Garmin o cualquier dispositivo compatible. Cada fuente que conectas desbloquea más datos en tu panel.",
  lp_step3_t: "Entiende y mejora",
  lp_step3_d: "Westive cruza tu rendimiento y tu salud en un panel claro. El Coach IA afina tu plan con todo el contexto.",
  lp_coach_eyebrow: "Para entrenadores",
  lp_coach_title: "El estado de tus atletas, en directo.",
  lp_coach_desc:
    "Controla día a día la salud y el rendimiento de cada atleta y anticípate a la fatiga antes de que se convierta en lesión, todo desde un único panel.",
  lp_coach_b1: "Reúne a todos tus atletas en un panel, con alertas de carga y recuperación.",
  lp_coach_b2: "Sigue su entrenamiento y su recuperación automáticamente, sin pedirles que te manden nada.",
  lp_coach_b3: "Programa los entrenos directamente en el perfil de cada atleta.",
  lp_coach_cta: "Quiero acceso de entrenador",
  lp_pricing_eyebrow: "Precios",
  lp_pricing_title: "Gratis durante la beta.",
  lp_pricing_desc:
    "Conecta y úsalo sin coste mientras construimos. Los planes de suscripción llegarán más adelante.",
  lp_plan_athlete_t: "Deportista",
  lp_plan_athlete_price: "Gratis en beta",
  lp_plan_athlete_d: "Todo tu rendimiento y tu salud, con el Coach IA.",
  lp_plan_coach_t: "Entrenador",
  lp_plan_coach_price: "Próximamente",
  lp_plan_coach_d: "Gestiona y programa a todos tus atletas desde un único panel.",
  lp_plan_cta: "Empezar gratis",
  lp_plan_cta_soon: "Próximamente",
  lp_faq_eyebrow: "Preguntas frecuentes",
  lp_faq_title: "Lo que sueles preguntar.",
  lp_faq_q1: "¿Qué necesito para empezar?",
  lp_faq_a1: "Solo un código de invitación beta. Te registras con email o Google y conectas tu Garmin u otra fuente compatible cuando quieras.",
  lp_faq_q2: "¿Tiene coste?",
  lp_faq_a2:
    "Durante la beta es gratis. Más adelante habrá planes de suscripción para deportistas y entrenadores.",
  lp_faq_q3: "¿Qué pasa con mis datos?",
  lp_faq_q4: "¿Cuándo llegan salud, IA y el panel de entrenador?",
  lp_faq_a4:
    "Lo estamos construyendo. Conecta ahora y crece con el producto: Garmin/salud, Coach IA y panel de entrenador están en camino.",
  lp_trust_read_t: "Solo lectura.",
  lp_trust_read_d:
    "Pedimos permiso para leer las actividades de tu dispositivo. Nunca publicamos, editamos ni borramos nada en tu cuenta.",
  lp_trust_store_t: "En nuestro servidor.",
  lp_trust_store_d:
    "Guardamos tus actividades para calcular tus métricas (carga, ritmos, zonas, material). Los tokens de acceso se almacenan cifrados.",
  lp_trust_sell_t: "Nunca vendemos tus datos.",
  lp_trust_sell_d:
    "No los compartimos con terceros ni hay anuncios. Tus datos son solo para tu panel.",
  lp_trust_control_t: "Tú mandas.",
  lp_trust_control_d:
    "Puedes desconectar y borrar todos tus datos cuando quieras, desde Ajustes.",
  lp_footer_tagline: "Rendimiento, salud e IA en un solo panel.",
  lp_footer_beta: "Hecho por y para deportistas.",
  lp_footer_col_product: "Producto",
  lp_footer_col_company: "Compañía",
  lp_footer_col_legal: "Legal",
  lp_link_features: "Características",
  lp_link_demo: "Demo",
  lp_link_about: "Sobre Westive",
  lp_link_contact: "Contacto",
  lp_link_privacy: "Privacidad",
  lp_link_terms: "Términos",
  lp_theme_aria: "Cambiar tema",
  lp_lang_aria: "Cambiar idioma",
  // Fuentes de datos
  sources_title: "Fuentes de datos",
  sources_connected: "Conectada",
  sources_connect: "Conectar",
  sources_disconnect: "Desconectar",
  sources_soon: "Próximamente",
  sources_sport: "Deporte",
  sources_health: "Salud",
  sources_disconnect_confirm: "¿Desconectar {provider}? Se borrarán sus actividades y datos de salud de tu panel.",
  sources_disconnect_last: "No puedes desconectar tu última fuente de datos.",
  sources_sport_primary: "Fuente de deporte preferida",
  sources_sport_primary_hint: "Cuando tengas varias fuentes de deporte, elige cuál tiene prioridad.",
  sources_unlock_sport: "Actividades y carga de entrenamiento",
  sources_unlock_health: "Sueño, HRV y métricas de salud",
  sources_unlock_both: "Deporte + salud completa",
  sources_upload_title: "Subir archivo de actividad",
  sources_upload_hint: "Importa un .gpx, .tcx o .fit exportado desde tu reloj u otra plataforma compatible. Se compartirá con tu entrenador como dato propio subido a Westive.",
  sources_upload_cta: "Subir GPX/TCX/FIT",
  sources_upload_ok: "Archivo importado. Ya aparece en tu panel y en la vista compartible del coach.",
  sources_upload_error: "No se pudo importar el archivo.",
  // Notificaciones in-app
  notif_title: "Notificaciones",
  notif_empty: "No tienes notificaciones",
  notif_mark_all_read: "Marcar todas como leídas",
  notif_coach_message_title: "Nuevo mensaje de tu entrenador",
  notif_workout_assigned_title: "Tu entrenador te ha asignado un entreno",
  notif_access_revoked_title: "Tu acceso ha sido pausado",
  notif_coach_link_title: "Un atleta se ha vinculado contigo",
  audit_title: "Quién ha accedido a tus datos",
  audit_empty: "Sin accesos registrados. Los accesos de tu entrenador aparecerán aquí.",
  audit_action_view: "vio",
  audit_action_mutate: "modificó",
  audit_action_ai_plan: "consultó la IA sobre",
  audit_res_dashboard: "tu panel",
  audit_res_activities: "tus actividades",
  audit_res_calendar: "tu calendario",
  audit_res_messages: "tus mensajes",
  audit_res_notes: "las notas de entrenador",
  audit_res_workouts: "tus entrenos planificados",
  audit_res_coach_ai: "tu perfil de atleta",
  audit_res_other: "tus datos",
};

const EN: Dict = {
  app_title: "Westive",
  acts_datos_al: "{n} activities · {update}",
  upd_today: "updated today",
  upd_yesterday: "updated yesterday",
  upd_days: "updated {d} days ago",
  warn_sync: "Your activity data hasn't synced in {d} days. Check your device connection.",
  warn_garmin:
    "Garmin hasn't synced in {d} days. The Garmin token may have expired: re-run garmin_login.py and update the GARMIN_TOKEN secret.",
  range_30d: "30 days",
  range_week: "Week",
  range_3m: "3 months",
  range_12m: "12 months",
  range_all: "All",
  tab_resumen: "Summary",
  tab_carrera: "Running",
  tab_material: "Gear",
  tab_carga: "Load",
  tab_coach: "Coach",
  tab_add: "Add sport",
  tab_add_empty: "No other sports with data.",
  sync: "Sync",
  syncing: "Syncing…",
  sync_rate_limited:
    "Strava temporarily rate-limited the sync. Progress is saved; try again in a few minutes.",
  sync_timeout:
    "Sync is still running in the background or took longer than expected. Refresh or try again in a few minutes.",
  // Coach (AI)
  coach_title: "Your AI Coach",
  coach_intro:
    "Ask me about your current fitness, today's workout or a proposal to organise next week. I know your zones, your load (CTL/ATL/TSB) and your latest sessions.",
  coach_placeholder: "Type your question… (Enter to send)",
  coach_send: "Send",
  coach_thinking: "Thinking…",
  coach_error: "Error",
  coach_disclaimer: "Experimental assistant. Not a substitute for medical or professional advice.",
  coach_s1: "How's my fitness?",
  coach_s2: "What workout should I do today?",
  coach_s3: "Organise my next week",
  coach_rate: "Too many requests in a row. Wait a few seconds and try again.",
  coach_credit: "{remaining}/{limit} estimated tokens",
  coach_credit_hint: "Estimated daily AI Coach credit. It resets at midnight UTC.",
  coach_goals: "Goals",
  coach_workouts: "Upcoming workouts",
  coach_no_goals: "No active goals.",
  coach_no_workouts: "No planned workouts.",
  coach_goal_placeholder: "Event or goal: Valencia Half Marathon, Hyrox Madrid…",
  coach_workout_placeholder: "Workout title",
  coach_workout_notes: "Notes, blocks, paces or zones",
  coach_add_goal: "Save goal",
  coach_save_goal: "Save changes",
  coach_add_workout: "Save workout",
  coach_mark_done: "Mark completed",
  coach_done_short: "Done",
  coach_pinned_goal: "Pinned goal",
  coach_goal_empty_desc:
    "Pin a goal so the Coach can contextualise your answers. No need to enter sport: it will infer it from the name.",
  coach_edit_goal: "Edit",
  coach_archive_goal: "Archive",
  coach_delete_goal: "Delete",
  coach_cancel_goal: "Cancel",
  coach_goal_saved: "Goal saved",
  coach_goal_archived: "Goal archived",
  coach_goal_deleted: "Goal deleted",
  coach_delete_goal_confirm: "Delete this goal? This can't be undone.",
  coach_memory_title: "Coach memory",
  coach_memory_desc:
    "Facts the Coach remembers about you across conversations (injuries, marks, preferences…). Use them so it tailors better.",
  coach_memory_empty: "No facts saved yet. Add anything you want the Coach to always keep in mind.",
  coach_memory_placeholder: "e.g. recurring left soleus niggle",
  coach_memory_add: "Add",
  coach_memory_save: "Save",
  coach_memory_delete_confirm: "Delete this fact from the Coach's memory?",
  coach_mem_kind_injury: "Injury",
  coach_mem_kind_preference: "Preference",
  coach_mem_kind_mark: "Mark/PR",
  coach_mem_kind_constraint: "Constraint",
  coach_mem_kind_equipment: "Equipment",
  coach_mem_kind_note: "Note",
  coach_memory_pending_title: "Suggestions to review",
  coach_memory_pending_desc:
    "The Coach spotted these facts in your conversations. Approve them so it remembers, or discard.",
  coach_memory_approve: "Approve",
  coach_memory_discard: "Discard",
  coach_memory_review_badge: "{n} to review",
  coach_goal_date: "Date: {date}",
  coach_goal_time: "Target time: {time}",
  coach_no_date: "No date",
  coach_no_time: "No target time",
  coach_no_goal_for_prompt: "no pinned goal yet",
  coach_ask_plan: "Ask Coach for a plan",
  coach_ask_plan_hint: "This prepares a chat prompt; persistent planning is reserved for the coach view.",
  coach_plan_prompt:
    "With my goal {goal}, propose a sensible plan for the next 2 weeks. Use my load, fatigue, form and health data if available. I want concrete sessions, rest days and adjustments if you detect risk.",
  coach_ask_load: "Ask Coach",
  coach_ask_period: "Analyse with Coach",
  coach_prompt_load_now:
    "Analyse my current training load with these values: date {date}, CTL {ctl}, ATL {atl}, TSB {tsb}. Tell me what I should train today and what risk you see.",
  coach_prompt_load_range:
    "Analyse this training period ({from} to {to}, {n} activities). Summarise what you see in load, fatigue and recovery, and suggest adjustments for next week.",
  coach_ask_health: "Analyse health with Coach",
  coach_prompt_health:
    "Review my recent health and recovery data (sleep, readiness, HRV, resting HR, Body Battery if available). Tell me how recovered I am and what I should train today.",
  coach_ask_overview: "Analyse overview with Coach",
  coach_prompt_overview:
    "Look at my recent training overview (volume, frequency and split by discipline). Tell me what looks good, what you'd fix and how to approach next week.",
  footer_by: "Created by",
  footer_contact: "Contact",
  egg_msg: "You've been blessed by Champi of Fortune — a year of good luck awaits you",
  egg_close: "Tap or click to close",
  cat_Carrera: "Running",
  cat_Ciclismo: "Cycling",
  cat_Natacion: "Swimming",
  cat_Hybrid: "Hybrid",
  cat_Hike: "Hike",
  cat_Musculacion: "Strength",
  cat_Otros: "Other",
  kpi_actividades: "Activities",
  kpi_kilometros: "Kilometres",
  kpi_horas: "Hours",
  kpi_carga_total: "Total load",
  kpi_calorias: "Calories",
  kpi_carreras: "Runs",
  kpi_km: "Km",
  kpi_ritmo_medio: "Avg pace",
  kpi_mejor_ritmo: "Best pace",
  kpi_sesiones: "Sessions",
  kpi_avg_hr: "Avg HR",
  kpi_fitness: "Fitness (CTL)",
  kpi_fatiga: "Fatigue (ATL)",
  kpi_forma: "Form (TSB)",
  kpi_over_days: "over {d} days",
  sec_volumen: "Weekly volume (km)",
  sec_reparto: "Split by type",
  sec_acts_periodo: "Activities in period",
  sec_ultimas: "Latest activities",
  sec_evol_ritmo: "Pace trend",
  sec_evol_velocidad: "Speed trend",
  sec_evol_potencia: "Power trend",
  sec_evol_ritmo100: "Pace trend (/100m)",
  sec_evol_esfuerzo: "Effort trend",
  m_speed: "Speed",
  m_power: "Power",
  m_elev: "Elevation",
  m_cadence: "Cadence",
  m_swolf: "SWOLF",
  m_kj: "Work",
  m_pace100: "Pace /100m",
  th_velocidad: "Spd.",
  th_potencia: "Pow.",
  th_cadencia: "Cad.",
  th_swolf: "SWOLF",
  th_ritmo100: "Pace /100m",
  d_velocidad: "Speed",
  d_potencia: "Power",
  d_cadencia: "Cadence",
  d_swolf: "SWOLF",
  d_temp: "Temperature",
  sec_zonas: "Time split by HR zone",
  sec_frecuencia: "Weekly frequency",
  sec_seguimiento: "Weekly tracking",
  sec_wods: "Session detail",
  sec_km_zapatilla: "Mileage per shoe",
  sec_ctl_atl: "Fitness (CTL) vs Fatigue (ATL)",
  sec_tsb: "Form (TSB = Fitness − Fatigue)",
  th_fecha: "Date",
  th_actividad: "Activity",
  th_tipo: "Type",
  th_km: "Km",
  th_ritmo: "Pace",
  th_tiempo: "Time",
  th_hr: "Avg HR",
  th_max_hr: "Max HR",
  th_esfuerzo: "Effort",
  th_carga: "Load",
  th_calorias: "Calories",
  pg_show: "Show",
  pg_prev: "Prev",
  pg_next: "Next",
  pg_page: "Page {page}/{total}",
  pg_of_total: "{from}–{to} of {total}",
  d_fecha_hora: "Date & time",
  d_deporte: "Sport",
  d_distancia: "Distance",
  d_duracion: "Duration",
  d_ritmo: "Pace",
  d_vel_media: "Avg speed",
  d_desnivel: "Elevation",
  d_calorias: "Calories",
  d_hr: "Avg HR",
  d_max_hr: "Max HR",
  d_carga: "Load (rel. effort)",
  d_kudos: "Kudos",
  d_pr: "Records (PR)",
  d_material: "Gear",
  m_entrenos: "Workouts",
  m_km: "Km",
  m_pace: "Pace",
  m_cal: "Calories",
  m_sesiones: "Sessions",
  m_horas: "Hours",
  m_carga: "Load",
  m_hr: "Avg HR",
  m_heatmap: "Heatmap",
  heat_menos: "less",
  heat_mas: "more",
  heat_hue: "color = sport · intensity = duration",
  hint_chart: "Click a week to filter · drag the bottom selector to zoom",
  hint_chart_day: "Click a day to filter · drag the bottom selector to zoom",
  hint_donut: "Click a type to filter",
  hint_dia: "Click a day to filter",
  hint_punto: "Click a point to see that activity",
  hint_semana: "Click a date to see that week's activities",
  hint_carga: "Click = week · drag to select a range",
  hint_fila: "click a row for details",
  txt_n_acts: "{n} activities",
  txt_sin_acts: "No activities in this period.",
  txt_sin_disciplina: "No {cat} activities in this range.",
  txt_sin_carga: "No load data.",
  gear_active: "In use",
  gear_retired: "Retired",
  gear_usage: "Usage",
  // HR zones (Strava names) and donut texts
  zone_1: "Recovery",
  zone_2: "Endurance",
  zone_3: "Tempo",
  zone_4: "Threshold",
  zone_5: "Anaerobic",
  z_tiempo: "Time",
  z_pct: "% of time",
  ref_zonas: "Approximated from each run's average HR (not from per-second streams).",
  ref_zapatillas: "Rule of thumb: review/replace road shoes between 600–900 km.",
  ref_tsb: "Positive TSB = rested · very negative TSB = accumulated fatigue (risky if sustained).",
  tsb_fatiga: "Accumulated fatigue",
  tsb_fresco: "Fresh",
  tsb_equilibrio: "Balanced",
  legend_fitness: "Fitness",
  legend_fatiga: "Fatigue",
  legend_forma: "Form",
  unit_min: "min",
  unit_sesiones: "sessions",
  info_carga:
    "Sum of your 'relative effort' over the shown period. A proxy for each session's stress (intensity × duration): the higher, the harder the training.",
  info_calorias:
    "Sum of estimated calories over the shown period (kcal). An estimate based on each activity's effort and duration.",
  info_ctl:
    "CTL = Chronic Training Load, i.e. Fitness: 42-day exponential moving average of load. Your accumulated base fitness — it rises slowly with sustained training.",
  info_atl:
    "ATL = Acute Training Load, i.e. Fatigue: 7-day exponential moving average of load. Recent tiredness — it rises quickly after hard sessions.",
  info_tsb:
    "TSB = Training Stress Balance, i.e. Form = Fitness − Fatigue. Positive = rested and ready; very negative = accumulated fatigue, risky if sustained.",
  // --- Health (Garmin) ---
  seg_fitness: "Fitness",
  seg_salud: "Health",
  seg_coach: "AI Coach",
  tab_s_resumen: "Summary",
  tab_s_sueno: "Sleep",
  tab_s_cuerpo: "Body",
  tab_s_cruce: "Readiness",
  h_sleep_score: "Sleep score",
  h_readiness: "Readiness",
  h_hrv: "HRV",
  h_rhr: "Resting HR",
  h_vo2: "VO2max",
  h_stress: "Stress",
  h_body_battery: "Body Battery",
  h_last_night: "last night",
  h_sleep_dur: "Sleep duration",
  h_resp: "Respiration",
  h_avg: "period average",
  h_total: "period total",
  h_kpis_caption: "Averages over the selected period",
  vo2_1: "Poor",
  vo2_2: "Below average",
  vo2_3: "Average",
  vo2_4: "Above average",
  vo2_5: "Good",
  vo2_6: "Excellent",
  sec_h_overview: "Readiness & sleep",
  sec_h_hrv: "HRV & resting HR",
  sec_h_sleep: "Sleep: stages (h) & score",
  sec_h_bb: "Body Battery & stress",
  sec_h_cross: "Form (TSB) vs recovery",
  st_deep: "Deep",
  st_light: "Light",
  st_rem: "REM",
  st_awake: "Awake",
  h_no_data: "No health data in this period.",
  h_cross_hint:
    "Cross your training load (TSB) with your recovery (Readiness & HRV, from Garmin).",
  h_corr_na: "not enough data",
  h_corr_weak: "weak correlation",
  h_corr_pos: "more form, better recovery",
  h_corr_neg: "more form, worse recovery",
  h_corr_tsb_hrv: "Correlation TSB ↔ HRV",
  h_corr_tsb_rdy: "Correlation TSB ↔ Readiness",
  h_steps: "Steps",
  health_distance: "Distance",
  body_title: "Body composition",
  body_weight: "Weight",
  body_fat: "Body fat %",
  body_muscle: "Muscle",
  body_chest: "Chest",
  body_waist: "Waist",
  body_hip: "Hip",
  body_arm: "Arm",
  body_thigh: "Thigh",
  body_note: "Note",
  body_add: "Save entry",
  body_empty: "No entries yet. Add your first body composition data.",
  body_date: "Date",
  body_del: "Delete",
  sec_h_vo2: "VO2max trend",
  sec_h_steps: "Daily steps",
  h_avg_hr: "HR",
  h_calories: "Calories",
  sec_h_activity: "Steps & calories",
  sec_h_sleepstress: "Sleep & stress",
  sec_h_avghr: "Daily avg & resting HR",
  info_h_avghr:
    "Average daily HR: the mean of your heart rate across the whole day (activity + rest). Higher on harder or more stressful days.",
  info_h_cal: "Total calories burned in the day per Garmin: basal metabolism (rest) + activity.",
  sec_h_hr_day: "Intraday HR (single day)",
  sec_h_table: "Daily summary",
  h_day: "Day",
  h_hr_bpm: "HR (bpm)",
  th_garmin: "Garmin",
  h_garmin_link: "View day on Garmin Connect",
  info_h_readiness:
    "Readiness (Garmin): 0–100 of how ready you are to train today. Combines recent sleep, HRV, acute load and recovery. High = ready for quality; low = prioritise rest.",
  info_h_hrv:
    "HRV: overnight heart-rate variability (ms). Reflects autonomic nervous-system balance; higher and stable usually means better recovery.",
  info_h_vo2:
    "VO2max: estimate of your maximal oxygen uptake (ml/kg/min). A proxy for aerobic capacity; rises with endurance training.",
  info_h_rhr:
    "Resting HR: beats per minute at rest. Tends to drop with fitness; spikes can signal fatigue or stress.",
  info_h_stress:
    "Stress (Garmin): 0–100 derived from HRV through the day. Low = relaxed/recovering; high = physical or mental strain.",
  info_h_sleep:
    "Sleep score (Garmin): 0–100 based on duration, stages (deep/REM/light), awakenings and overnight stress.",
  info_h_bb:
    "Body Battery: 0–100 estimated energy. Recharges with rest and sleep; drains with activity and stress.",

  // Calendar / planned_workouts (EN)
  tab_calendario: "Calendar",
  cal_plan_tab: "Plan",
  cal_week_prev: "← Prev",
  cal_week_next: "Next →",
  cal_month_prev: "Prev",
  cal_month_next: "Next",
  cal_activity_done: "Done",
  cal_no_workouts: "No workouts planned this month.",
  cal_empty_athlete: "No workouts from your coach this month.",
  cal_new_workout: "New workout",
  cal_edit_workout: "Edit workout",
  cal_title_label: "Title",
  cal_sport_label: "Sport",
  cal_intensity_label: "Intensity",
  cal_duration_label: "Duration (min)",
  cal_description_label: "Notes / description",
  cal_status_label: "Status",
  cal_status_draft: "Draft",
  cal_status_published: "Published",
  cal_status_done: "Done",
  cal_status_skipped: "Skipped",
  cal_save: "Save",
  cal_publish: "Save & publish",
  cal_delete: "Delete",
  cal_cancel: "Cancel",
  cal_delete_confirm: "Delete this workout? This cannot be undone.",
  cal_mark_done: "Mark done",
  cal_mark_skipped: "Skip",
  cal_today: "Today",
  cal_open_picker: "Select month",
  cal_int_easy: "Easy",
  cal_int_moderate: "Moderate",
  cal_int_hard: "Hard",
  cal_int_rest: "Rest",
  cal_sport_Hyrox: "Hyrox",
  cal_sport_Fuerza: "Strength",
  cal_sport_Movilidad: "Mobility",
  cal_sport_Descanso: "Rest",
  cal_sport_Otro: "Other",
  // Coach panel (EN)
  coach_view_athlete: "My training",
  coach_view_coach: "Coach zone",
  coach_roster_title: "My athletes",
  coach_subtab_athletes: "Athletes",
  nav_group_principal: "Main",
  nav_group_red: "Network",
  nav_entrenamiento: "Training",
  nav_collapse: "Collapse sidebar",
  nav_expand: "Expand sidebar",
  nav_red_athlete: "My coach",
  nav_red_entrenador: "Coach",
  nav_red_coach: "Athletes",
  nav_red_coach_zone: "Coach Zone",
  nav_red_messages: "Messages",
  nav_red_codes: "Codes",
  nav_settings: "Settings",
  profile_role_athlete: "Athlete",
  profile_role_coach: "Coach",
  coach_roster_empty: "No linked athletes yet.",
  coach_roster_empty_hint: "Share your coach code with your athletes so they can link to your panel.",
  coach_col_athlete: "Athlete",
  coach_col_tsb: "Form",
  coach_col_readiness: "Readiness",
  coach_col_sleep: "Sleep",
  coach_col_bb: "Body Battery",
  coach_col_sessions: "Sessions (wk)",
  coach_back_roster: "← My athletes",
  coach_athlete_read: "Athlete profile",
  // Coach notes (EN)
  tab_notes: "Notes",
  notes_empty: "No notes about this athlete yet.",
  notes_new_placeholder: "New note…",
  notes_visibility_private: "Private",
  notes_visibility_shared: "Shared",
  notes_add: "Add note",
  notes_save: "Save",
  notes_cancel: "Cancel",
  notes_delete: "Delete",
  notes_delete_confirm: "Delete this note?",
  notes_shared_badge: "Shared",
  notes_private_badge: "Private",
  // Coach link codes (Fase 7)
  my_coach_tab: "My coach",
  my_coach_no_coach: "You don't have a linked coach.",
  my_coach_enter_code: "Enter your coach's code",
  my_coach_code_placeholder: "CCH-XXXXXXX",
  my_coach_preview: "Verify code",
  my_coach_consent_title: "Link coach",
  my_coach_consent_body: "This code links you to {coachName}. The coach will be able to see your training and health data.",
  my_coach_consent_accept: "Accept and link",
  my_coach_consent_cancel: "Cancel",
  my_coach_linked: "Linked coach",
  my_coach_unlink: "Unlink",
  my_coach_unlink_confirm: "Unlink coach? They will no longer see your data.",
  my_coach_error_invalid: "Invalid or not found code.",
  my_coach_error_exhausted: "This code has been used the maximum number of times.",
  my_coach_error_expired: "This code has expired.",
  my_coach_error_self: "You cannot use your own code.",
  my_coach_error_already: "You already have a linked coach.",
  my_coach_updates: "Upcoming workouts",
  my_coach_no_updates: "No upcoming workouts from your coach.",
  my_coach_see_calendar: "See in calendar",
  my_coach_unlink_section: "Link settings",
  my_coach_no_shareable_banner: "Your coach can't see your data yet because you have no shareable source connected. Connect a Garmin device or other compatible source in Settings so your coach can see your progress.",
  coach_roster_no_shareable: "No shareable source",
  flag_fatigue_high: "High fatigue",
  flag_fatigue_high_desc: "TSB very negative: accumulated fatigue risk. Consider reducing load.",
  flag_form_peaked: "Peak form",
  flag_form_peaked_desc: "High TSB with sustained load: athlete is fresh. May detrain if extended.",
  flag_readiness_low: "Low readiness",
  flag_readiness_low_desc: "Readiness below 35. Athlete may need rest.",
  flag_inactive: "Inactive",
  flag_inactive_desc: "No sessions in the last 7 days.",
  flag_missed_workouts: "Missed workouts",
  flag_missed_workouts_desc: "Has past-due planned workouts not completed.",
  link_codes_title: "Link codes",
  link_codes_new: "New code",
  link_codes_copy: "Copy",
  link_codes_copied: "Copied!",
  link_codes_disable: "Disable",
  link_codes_enable: "Enable",
  link_codes_empty: "No link codes yet. Create one to share with your athletes.",
  link_codes_uses: "{uses} / {max} uses",
  link_codes_uses_unlimited: "{uses} uses (no limit)",
  link_codes_note_placeholder: "Optional note (athlete name, group…)",
  link_codes_max_placeholder: "Max uses (empty = no limit)",
  // Direct messaging (Fase 8)
  msg_tab: "Messages",
  msg_empty: "No messages yet. Start the conversation!",
  msg_placeholder: "Write a message…",
  msg_send: "Send",
  msg_you: "You",
  // Landing (pre-login). lp_ prefix = landing page.
  lp_soon: "Soon",
  lp_nav_features: "Product",
  lp_nav_coaches: "Coaches",
  lp_nav_pricing: "Pricing",
  lp_nav_faq: "FAQ",
  lp_signin: "Sign in",
  // Alternatives: "Train smart. Live strong." / "Train hard. Live healthy." / "Your training and health, one account."
  lp_tagline: "Performance and health, in sync.",
  lp_badge: "Performance + Health + AI — Garmin & more",
  lp_subtitle:
    "Connect your Garmin or any compatible device and bring your performance and health into one dashboard. With an AI Coach that understands your full history.",
  lp_cta: "Create account",
  lp_cta_secondary: "Watch demo",
  demo_badge: "You're viewing a demo",
  demo_cta_signup: "Sign up",
  demo_exit: "Exit demo",
  demo_locked: "Available once you sign up",
  lp_cta_note: "Closed beta · Garmin & more · Access with invite code.",
  // AuthModal (F1 own identity)
  auth_tab_register: "Create account",
  auth_tab_login: "Sign in",
  auth_email_label: "Email address",
  auth_email_placeholder: "you@email.com",
  auth_password_label: "Password",
  auth_password_placeholder: "At least 8 characters",
  auth_code_label: "Invite code",
  auth_code_placeholder: "Your code (BET… or CCH…)",
  auth_password2_label: "Confirm password",
  auth_password2_placeholder: "Repeat your password",
  auth_err_password_mismatch: "Passwords don't match.",
  auth_register_btn: "Create account",
  auth_login_btn: "Sign in",
  auth_google_btn: "Continue with Google",
  auth_err_email_invalido: "Invalid email address.",
  auth_err_password_corto: "Password must be at least 8 characters.",
  auth_err_invitacion_requerida: "You need an invite code.",
  auth_err_code_before_google: "Enter your invite code before continuing with Google.",
  auth_err_codigo_invalido: "Invalid or already used code.",
  auth_err_codigo_caducado: "Code has expired.",
  auth_err_codigo_agotado: "Code is exhausted.",
  auth_err_email_en_uso: "This email already has an account.",
  auth_err_email_solo_google: "This email already has a Google account. Use the 'Sign in with Google' button.",
  auth_err_credenciales_incorrectas: "Incorrect email or password.",
  auth_err_acceso_pausado: "Your access is paused.",
  auth_err_registro_fallido: "We couldn't create the account. Please try again or contact us.",
  auth_err_generic: "Unexpected error. Please try again.",
  auth_consent_title: "Your coach wants to connect",
  auth_consent_body: "{coachName} wants to be your coach on Westive. By accepting, they can see your training data from shareable sources. You can unlink at any time.",
  auth_consent_accept: "Accept and create account",
  auth_consent_cancel: "Cancel",
  identity_section: "Account & identity",
  identity_method_password: "Password",
  identity_link_google: "Link Google",
  // EmptyState (F)
  empty_no_activities: "No activities yet",
  empty_no_activities_desc: "Connect a source or wait while we finish syncing.",
  empty_no_health: "No health data",
  empty_no_health_desc: "Connect Garmin or another health source to see your metrics.",
  empty_no_gear: "No gear registered",
  empty_no_gear_desc: "Gear appears automatically when you sync your activities.",
  empty_cta_connect: "Connect source",
  empty_syncing: "Syncing your data…",
  // ConnectSources (F2)
  connect_title: "Your account is ready",
  connect_desc: "Connect your Garmin or another source to start seeing your data. You can do it now or later from Settings.",
  connect_skip: "Skip for now",
  connect_go: "Connect",
  // Access paused screen (blocked user)
  blocked_title: "Access paused",
  blocked_desc: "Your beta access is paused. Reach out if you think this is a mistake.",
  blocked_logout: "Log out",
  // Admin panel
  admin_title: "Admin",
  admin_loading: "Loading…",
  admin_slots: "Provider slots",
  admin_slots_desc: "connected athletes of {cap}",
  admin_codes: "Invite codes",
  admin_users: "Users",
  admin_create_code: "Create code",
  admin_prefix: "Prefix (3 letters)",
  admin_prefix_hint: "3 letters A-Z, e.g. BET",
  admin_code_kind_beta: "Beta (access)",
  admin_code_kind_coach: "Coach link",
  admin_code_coach_label: "Coach to link",
  admin_code_max_unlimited: "Unlimited",
  admin_code_delete: "Delete",
  admin_code_delete_confirm: "Delete this code? It will be hidden from the panel but its data is kept.",
  admin_note: "Note (optional)",
  admin_type_athlete: "Athlete",
  admin_type_coach: "Coach",
  admin_st_active: "Active",
  admin_st_disabled: "Disabled",
  admin_st_redeemed: "Redeemed",
  admin_copy: "Copy",
  admin_copied: "Copied!",
  admin_enable: "Enable",
  admin_disable: "Disable",
  admin_block: "Block",
  admin_unblock: "Unblock",
  admin_revoke: "Revoke",
  admin_revoke_confirm:
    "Revoke this user's access? This deauthorizes the source (frees a slot) and deletes their data. They'll need a new code to return.",
  admin_revoke_manual:
    "Access revoked and data deleted, but we couldn't disconnect from the source automatically. To free the slot, the athlete must revoke Westive manually from the provider's app.",
  admin_revoke_notoken:
    "Done in Westive, but this account no longer had a stored connection, so we can't disconnect it from the provider for you. To make the counter drop, the athlete must revoke Westive from their provider's settings.",
  admin_slots_note:
    "Counts active connections in Westive. The provider only frees its own counter when we deauthorize the athlete (revoke/delete while connected) or when they remove our access from their own account.",
  admin_no_slots: "No limited-cap providers are configured.",
  admin_ai_usage: "AI usage (Coach)",
  admin_ai_usage_desc: "Estimated AI Coach consumption to keep an eye on Workers AI cost during the beta.",
  admin_ai_today: "Today",
  admin_ai_week: "7 days",
  admin_ai_month: "30 days",
  admin_ai_all: "Total",
  admin_ai_tokens_est: "Estimated tokens (characters ÷ 4). Today resets at midnight UTC.",
  admin_ai_user: "User",
  admin_ai_requests: "Requests",
  admin_ai_anon: "(no name)",
  admin_connected: "Connected",
  admin_disconnected: "Disconnected",
  admin_connected_hint: "Has a connected source: revoking/deleting will free their slot at the provider.",
  admin_disconnected_hint:
    "No connected source in Westive: we can't disconnect them from the provider; they must revoke from their own account.",
  admin_delete: "Delete",
  admin_delete_confirm:
    "Permanently delete this user and ALL their data? If still connected, their slot at the provider is freed. This can't be undone.",
  admin_blocked: "Blocked",
  admin_active: "Active",
  admin_activities: "act.",
  admin_never: "no sync",
  admin_redeemed_by: "by",
  admin_no_codes: "No codes yet.",
  admin_no_users: "No users yet.",
  lp_features_eyebrow: "All in one place",
  lp_features_title: "Performance and health, connected.",
  lp_pillar_perf_t: "Performance",
  lp_pillar_perf_d:
    "Volume, paces, power and load —fitness, fatigue and form—. Every activity analyzed with the depth you need to progress.",
  lp_pillar_health_t: "Health",
  lp_pillar_health_d:
    "Sleep, heart rate, HRV, stress and body battery from your watch. Listen to your body to train better.",
  lp_pillar_ai_t: "AI Coach",
  lp_pillar_ai_d:
    "A smart coach that reads your data, plans your sessions and tells you when to ease off.",
  lp_how_eyebrow: "How it works",
  lp_how_title: "Get started in a minute.",
  lp_step1_t: "Create your account",
  lp_step1_d: "Sign up with email or Google. No credit card, nothing to configure.",
  lp_step2_t: "Connect your sources",
  lp_step2_d: "Link your Garmin or any compatible device. Each source you add unlocks more data in your dashboard.",
  lp_step3_t: "Understand and improve",
  lp_step3_d: "Westive cross-references your performance and health in a clear dashboard. The AI Coach refines your plan with full context.",
  lp_coach_eyebrow: "For coaches",
  lp_coach_title: "Your athletes' status, live.",
  lp_coach_desc:
    "Keep daily tabs on each athlete's health and performance and get ahead of fatigue before it turns into injury — all from a single dashboard.",
  lp_coach_b1: "Bring all your athletes into one dashboard, with load and recovery alerts.",
  lp_coach_b2: "Follow their training and recovery automatically — no need to ask them to send you anything.",
  lp_coach_b3: "Program workouts straight into each athlete's profile.",
  lp_coach_cta: "I want coach access",
  lp_pricing_eyebrow: "Pricing",
  lp_pricing_title: "Free during the beta.",
  lp_pricing_desc:
    "Connect and use it at no cost while we build. Subscription plans are coming later.",
  lp_plan_athlete_t: "Athlete",
  lp_plan_athlete_price: "Free in beta",
  lp_plan_athlete_d: "All your performance and health, with the AI Coach.",
  lp_plan_coach_t: "Coach",
  lp_plan_coach_price: "Coming soon",
  lp_plan_coach_d: "Manage and program all your athletes from a single dashboard.",
  lp_plan_cta: "Start free",
  lp_plan_cta_soon: "Coming soon",
  lp_faq_eyebrow: "Frequently asked",
  lp_faq_title: "What people usually ask.",
  lp_faq_q1: "What do I need to start?",
  lp_faq_a1: "Just a beta invite code. Sign up with email or Google and connect your Garmin or another compatible source whenever you like.",
  lp_faq_q2: "Does it cost anything?",
  lp_faq_a2:
    "It's free during the beta. Later there will be subscription plans for athletes and coaches.",
  lp_faq_q3: "What happens with my data?",
  lp_faq_q4: "When do health, AI and the coach dashboard arrive?",
  lp_faq_a4:
    "We're building it. Connect now and grow with the product: Garmin/health, AI Coach and coach dashboard are on the way.",
  lp_trust_read_t: "Read-only.",
  lp_trust_read_d:
    "We ask permission to read your device's activities. We never post, edit or delete anything in your account.",
  lp_trust_store_t: "On our server.",
  lp_trust_store_d:
    "We store your activities to compute your metrics (load, paces, zones, gear). Access tokens are stored encrypted.",
  lp_trust_sell_t: "We never sell your data.",
  lp_trust_sell_d:
    "We don't share it with third parties and there are no ads. Your data is only for your dashboard.",
  lp_trust_control_t: "You're in control.",
  lp_trust_control_d:
    "You can disconnect and delete all your data whenever you want, from Settings.",
  lp_footer_tagline: "Performance, health and AI in one dashboard.",
  lp_footer_beta: "Built by and for athletes.",
  lp_footer_col_product: "Product",
  lp_footer_col_company: "Company",
  lp_footer_col_legal: "Legal",
  lp_link_features: "Features",
  lp_link_demo: "Demo",
  lp_link_about: "About Westive",
  lp_link_contact: "Contact",
  lp_link_privacy: "Privacy",
  lp_link_terms: "Terms",
  lp_theme_aria: "Toggle theme",
  lp_lang_aria: "Toggle language",
  // Data sources
  sources_title: "Data sources",
  sources_connected: "Connected",
  sources_connect: "Connect",
  sources_disconnect: "Disconnect",
  sources_soon: "Coming soon",
  sources_sport: "Sport",
  sources_health: "Health",
  sources_disconnect_confirm: "Disconnect {provider}? Its activities and health data will be removed from your dashboard.",
  sources_disconnect_last: "You can't disconnect your last data source.",
  sources_sport_primary: "Preferred sport source",
  sources_sport_primary_hint: "When you have multiple sport sources, choose which one takes priority.",
  sources_unlock_sport: "Activities and training load",
  sources_unlock_health: "Sleep, HRV and health metrics",
  sources_unlock_both: "Sport + full health",
  sources_upload_title: "Upload activity file",
  sources_upload_hint: "Import a .gpx, .tcx or .fit exported from your watch or another compatible platform. It will be shared with your coach as athlete-owned data uploaded to Westive.",
  sources_upload_cta: "Upload GPX/TCX/FIT",
  sources_upload_ok: "File imported. It now appears in your dashboard and in the coach's shareable view.",
  sources_upload_error: "The file could not be imported.",
  // In-app notifications
  notif_title: "Notifications",
  notif_empty: "No notifications yet",
  notif_mark_all_read: "Mark all as read",
  notif_coach_message_title: "New message from your coach",
  notif_workout_assigned_title: "Your coach assigned you a workout",
  notif_access_revoked_title: "Your access has been paused",
  notif_coach_link_title: "An athlete has linked to you",
  audit_title: "Who accessed your data",
  audit_empty: "No accesses recorded. Your coach's accesses will appear here.",
  audit_action_view: "viewed",
  audit_action_mutate: "modified",
  audit_action_ai_plan: "ran AI on",
  audit_res_dashboard: "your dashboard",
  audit_res_activities: "your activities",
  audit_res_calendar: "your calendar",
  audit_res_messages: "your messages",
  audit_res_notes: "coach notes",
  audit_res_workouts: "your planned workouts",
  audit_res_coach_ai: "your athlete profile",
  audit_res_other: "your data",
};

const DICTS: Record<Lang, Dict> = { es: ES, en: EN };

export function detectLang(): Lang {
  if (typeof navigator === "undefined") return "es";
  return navigator.language?.toLowerCase().startsWith("es") ? "es" : "en";
}

export type TFunc = (key: string, vars?: Record<string, string | number>) => string;

export function makeT(lang: Lang): TFunc {
  const dict = DICTS[lang] ?? ES;
  return (key, vars) => {
    let s = dict[key] ?? ES[key] ?? key;
    if (vars) {
      for (const [k, v] of Object.entries(vars)) {
        s = s.replace(`{${k}}`, String(v));
      }
    }
    return s;
  };
}
